<template>
  <el-dialog
    title="下载客户端"
    :visible.sync="dialogVisible"
    width="30%"
    :before-close="handleClose"
    class="modal-dialog"
  >
    <div class="flex">
      <div class="flex-col-center">
        <div class="platform">移动端</div>
        <img src="@/assets/img/modal-app-code.png" class="modal-code" alt />
        <div class="btn-app">扫码下载APP</div>
      </div>
      <div class="split-line"></div>
      <div class="flex-col-center">
        <div class="platform">电脑端</div>
        <img src="@/assets/img/modal-pc.png" class="modal-code modal-code-pc" alt />
        <div class="btn-group">
          <a class="btn-pc" clstag="DSGJ|downloadWindowsEnd" :href="downloadInfo.windowsLink">
            <img src="@/assets/img/modal-win-icon.png" alt />
            <span>Windows版</span>
          </a>
          <a class="btn-pc" clstag="DSGJ|downloadMac" :href="downloadInfo.macLink">
            <img src="@/assets/img/modal-mac-icon.png" alt />
            <span>macOS版</span>
          </a>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: "Modal",

  props: ["dialogVisible"],

  data() {
    return {
      downloadInfo: {},
    }
  },

  created() {
    this.getDownloadInfo()
  },

  mounted() {},

  methods: {
    handleClose() {
      this.$emit("clsoeModal", false);
    },

    getDownloadInfo() {
      let xhr = new XMLHttpRequest()
      xhr.open('GET', 'https://show.jd.com/cms-file/ACTIVITY_PRODUCT/online/ACT476326621_2099.json', true)
      xhr.onreadystatechange = () => {
        if (xhr.readyState == 4 && xhr.status == 200) {
          let data = JSON.parse(xhr.responseText)
          this.downloadInfo = data
        }
      }
      xhr.send()
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/mixin.scss';
::v-deep .el-dialog {
  width: 800px !important;
  height: 464px;
  // margin-top: 35vh !important;
  // transform: translateY(toRem(-132)) !important;
  margin-top: calc(50vh - 300px) !important;
  transform: scale(1.3);
  transform-origin: top;
  .el-dialog__header {
    padding: 0;
    height: 48px;
    line-height: 48px;
    padding-left: 24px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid  rgba(0,0,0,0.06);
  }
  .el-dialog__body {
    padding: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    .flex {
      display: flex;
    }
    .flex-col-center {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .split-line {
      width: 1px;
      height: 240px;
      background: rgba(0,0,0,0.06);
      margin: 105px 60px 0 70px;
    }

    .platform {
      font-size: 20px;
      font-weight: 600;
      color: rgba(0,0,0,0.85);
      margin-top: 52px;
    }

    .btn-app, .btn-pc {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 172px;
      height: 48px;
      border: 1px solid rgba(204,204,204,1);
      border-radius: 24px;
      text-align: center;
      font-size: 18px;
      color: #000;
    }

    .btn-pc {
      background-color: #000;
      color: #fff;
      cursor: pointer;
      text-decoration: none;

      img {
        height: 22px;
        width: 22px;
        margin-right: 6px;
      }
    }

    .btn-group {
      display: flex;
      
      .btn-pc + .btn-pc {
        margin-left: 20px;
      }
    }
    
    .modal-code {
      width: 160px;
      height: 160px;
      position: relative;
      z-index: 10;
      margin: 25px 0 32px;
    }

    .modal-code-pc {
      width: 200px;
    }
  }
}
</style>